import { defineRecipe } from "@chakra-ui/react";

export const buttonRecipe = defineRecipe({
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "body",
    fontWeight: "semibold",
    textStyle: "sm",
    colorPalette: "primary",
    h: "8",
    px: "4",
    transition: "background 0.2s, color 0.2s, transform 0.1s",
    _active: { transform: "scale(0.98)" },
    _focusVisible: {
      outline: "2px solid",
      outlineColor: "colorPalette.focusRing",
      outlineOffset: "2px",
    },
    rounded: "full",
  },

  variants: {
    visual: {
      solid: {
        bg: "colorPalette.solid",
        color: "colorPalette.contrast",
        _hover: {
          bg: "colorPalette.emphasized",
          color: "colorPalette.muted",
        },
        _active: {
          bg: "colorPalette.fg",
        },
        _disabled: {
          cursor: "not-allowed",
        },
      },

      outline: {
        borderWidth: "1px",
        borderColor: "colorPalette.solid",
        color: "colorPalette.fg",
        bg: "transparent",
        _hover: {
          bg: "colorPalette.muted",
        },
        _active: {
          bg: "colorPalette.subtle",
        },
        _disabled: {
          opacity: 0.5,
        },
      },

      ghost: {
        color: "colorPalette.fg",
        bg: "transparent",
        _hover: {
          bg: "colorPalette.muted",
        },
        _active: {
          bg: "colorPalette.subtle",
        },
        _disabled: {
          opacity: 0.5,
        },
      },

      tag: {
        fontWeight: "medium",
        borderWidth: "1px",
        borderColor: "transparent",
        bg: "colorPalette.muted",
        color: "colorPalette.fg",
        _hover: {
          bg: "colorPalette.subtle",
          borderColor: "colorPalette.subtle",
        },
      },

      "none-style": {
        bg: "transparent",
        color: "colorPalette.fg",
        shadow: "none",
        _hover: {
          bg: "colorPalette.muted",
          shadow: "sm",
        },
      },
    },
  },

  defaultVariants: {
    visual: "solid",
  },
});
